<!-- 智慧水厂大屏 - HeaderNav 效果切换 -->
<template>
  <div class="water-plant-container">
    <div class="showcase-area">
      <HeaderNav />
    </div>
  </div>
</template>

<script>
import HeaderNav from './modules/HeaderNav.vue'

export default {
  name: 'WaterPlantLargeScreen',
  components: {
    HeaderNav
  }
}
</script>

<style scoped lang="less">
.water-plant-container {
  width: 100vw;
  height: 100vh;
  background: url('~@/assets/waterWorks/background.png') no-repeat center/cover;
  position: relative;
  overflow-x: auto;
  overflow-y: auto;

  /* 核心：营造四周压暗、中心通透的"液态框"感 */
  &::after {
    content: '';
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 10;
  }

  .showcase-area {
    position: relative;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 30px 20px;
    min-height: 100vh;
  }

  .preview-card {
    position: relative;
    width: 820px;
    height: 260px;
    border-radius: 24px;
    overflow: hidden;
    isolation: isolate;
    margin-top: 0;
  }

  .preview-card-backdrop,
  .preview-card-cover,
  .preview-card-edge,
  .preview-card-highlight {
    position: absolute;
    inset: 0;
    border-radius: inherit;
    pointer-events: none;
  }

  .preview-card-backdrop {
    z-index: 0;
    background:
      radial-gradient(130% 130% at 0% 0%, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0.05) 38%, transparent 72%),
      linear-gradient(155deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.03) 30%, rgba(18, 38, 72, 0.24) 100%);
    backdrop-filter: blur(10px) saturate(142%);
    -webkit-backdrop-filter: blur(10px) saturate(142%);
  }

  .preview-card-cover {
    z-index: 1;
    background:
      linear-gradient(180deg, rgba(255, 255, 255, 0.26) 0%, rgba(255, 255, 255, 0.05) 32%, rgba(255, 255, 255, 0) 66%),
      radial-gradient(100% 140% at 100% 100%, rgba(101, 182, 255, 0.2) 0%, transparent 65%);
  }

  .preview-card-edge {
    z-index: 2;
    border: 1px solid rgba(255, 255, 255, 0.32);
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.5),
      inset 0 -1px 0 rgba(255, 255, 255, 0.08),
      0 12px 36px rgba(8, 19, 42, 0.25);
  }

  .preview-card-highlight {
    z-index: 3;
    background:
      radial-gradient(70% 180% at -10% -40%, rgba(255, 255, 255, 0.45) 0%, rgba(255, 255, 255, 0) 70%),
      radial-gradient(80% 220% at 110% 140%, rgba(255, 255, 255, 0.22) 0%, rgba(255, 255, 255, 0) 75%);
    mix-blend-mode: screen;
  }

  .toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .label {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.82);
    background: rgba(8, 17, 30, 0.48);
    padding: 6px 16px;
    border-radius: 20px;
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.16);
    white-space: nowrap;
  }

}
</style>
